<template id="bannerTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>

    <!-- Snackbar -->
    <div id="snackbar" class="snackbar alert">{{serverMessage}}</div>

    <div class="main-div">
      <div class="p-2 row">
        <div class="col-12">
        <h3 class="text-left">Tailor Expenses</h3>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="tailor_expenses"></label>
            <input type="number" id="tailor_expenses" class="form-control" v-model="tailor_expenses" aria-describedby="helpId">
            <small id="helpId" class="text-muted">Basic expenses for tailor transportation</small>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="tailor_extra_expenses"></label>
            <input type="number" id="tailor_extra_expenses" class="form-control" v-model="tailor_extra_expenses" aria-describedby="helpId2">
            <small id="helpId2" class="text-muted">Extra expenses when the pieces less than 3</small>
          </div>
        </div>
        <div class="col-12 text-right"><div class="btn btn-primary" v-on:click="updateExpenses()">Update Expenses</div></div>

      </div>
      <div class="p-2 header">
            <h3 class="text-left">Tailor Orders</h3>
          </div>
      <!-- Loading -->
      <div class="spinner-wrapper" v-bind:class="isLoading ? 'show' : 'hide'">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <p class="alert alert-danger text-left" v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
      </p>

        <div role="tablist">
          <b-card-header header-tag="header" class="p-1 pt-2 pb-2" role="tab">
              <b-button block  variant="info" class="d-flex cartTap"><span>Order #</span> <span>User Name</span><span>User Mobile</span><span>User Email</span><span>User Country</span></b-button>
            </b-card-header>
          <b-card no-body class="col-12 mb-1 p-0" v-for="(order, index) in this.orders" :key="index+1">
            
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-' + (index+1)" variant="info" class="d-flex cartTap"><span>Order #{{index+1}} </span> <span v-if="order.User">{{order.User.name}}</span><span v-if="order.User">{{order.User.mobile}}</span><span v-if="order.User">{{order.User.email}}</span><span v-if="order.User">{{order.User.Place.Country.name}}</span></b-button>
            </b-card-header>
            <b-collapse :id="'accordion-' + (index+1)" accordion="my-accordion" role="tabpanel">
              <b-card-body class="row text-left">
                <label for="status" class="status-label">Change Order Status</label>
                <div class="form-group status-form">
                  <select class="form-control" name="status" id="status" v-model="order.status">
                    <option value="new">New</option>
                    <option value="in_progress">In Progress</option>
                    <option value="production">Production</option>
                    <option value="delivered">Delivered</option>
                    <option value="canceled">Canceled</option>
                  </select>
                  <button type="button" class="btn btn-primary" v-on:click="updateOrderStatus(order)">Submit</button>
                </div>
                
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Region Name</th>
                      <th scope="col">Naighborhood Name</th>
                      <th scope="col">Street </th>
                      <th scope="col">Neraby Milestone</th>
                      <th scope="col">Suitable Time</th>
                      <th scope="col">Pieces Number</th>
                      <th scope="col">Other Details</th>
                      <th scope="col">Status</th>
                      <th scope="col">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr >
                      <th scope="row">#{{index+1}}</th>
                      <td>{{order.region}}</td>
                      <td>{{order.naighborhood}}</td>
                      <td>{{order.street}}</td>
                      <td>{{order.milestone}}</td>
                      <td>{{`from : ${order.from} : to : ${order.to}`}}</td>
                      <td>{{order.pieces_number}}</td>
                      <td>{{order.details}}</td>
                      <td>{{order.status}}</td>
                      <td>{{order.createdAt.replace('T', ' ').replace('.000Z', '')}}</td>
                    </tr>
                  </tbody>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans");
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.status-label{
  display: block;
  width: 100;
}
.status-form{
  width: 50%;
  display: flex;
  select{
    flex:3
  }
  button{
    flex:1
  }
}
.toolbar {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  right: 0;
  padding: 10px 50px;
  background: #fff;
  border-bottom: 1px solid #eee;
  z-index: 99;
}

h1 {
  margin-bottom: 0;
}

.card {
  transition: all 150ms ease-in-out;

  &:hover {
    background: #fafafa;
  }
}

.img-preview {
  max-height: 500px;
  text-align: center;

  img {
    width: auto;
    max-width: 100%;
    height: 100%;
  }
}

.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}

.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  margin-top: 50px;
  padding: 50px;
  width: 80%;
}

.spinner-wrapper {
  display: none;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 100%;
  top: 0;
  right: 0;
  background: rgba(230, 230, 230, 0.61);
  z-index: 99;
}
.spinner-wrapper.show {
  display: flex;
}
.spinner-wrapper.hide {
  display: none;
}

.spinner-border {
  width: 3.5rem;
  height: 3.5rem;
}

.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

/* The snackbar - position it at the bottom and in the middle of the screen */
.snackbar {
  position: fixed;
  bottom: -100px;
  left: 40%;
  z-index: 1;
  transition: all 300ms ease-in-out;
}

.snackbar.show {
  bottom: 30px;
  opacity: 1;
}
.cartTap{
  display: flex;
  span{
    
    width: 20%;
    border-right: 1px solid #fff;
    &:first-child{
      text-align: left;
      width: 10%;
    }
    &:last-child{
      border-right: none;
    }
    &:nth-child(2){
      width: 25%;
    }
    &:nth-child(4){
      width: 25%;
    }
  }
}
  .header {
    padding-top: 16px !important;
    background: black;
    color: #b78b1e;
  }
</style>

<script>
import axios from "axios";
import { getCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "banner",
  data() {
    return {
      orders: [],
      tailor_expenses: 0,
      tailor_extra_expenses: 0,
      errors: [], // Form's errors
      serverMessage: "",
      isLoading: false
    };
  },
  watch: {},
  mounted() {
    this.fetchTailorOrders();
  },
  methods: {
    updateExpenses(){
      // Show Loader
      this.isLoading = true;
      // Get Slides Data
      return axios
        .post(`${herokuUrl}/tailor_expenses_update`, {tailor_extra_expenses:this.tailor_extra_expenses, man_price:this.tailor_expenses}, {
          headers: {
            Authorization: getCookie("user"),
          },
        })
        .then((res) => {
          console.log(res.data);
          alert("Tailor Expenses Updated Successfully");

          // Stop the loader
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 401) {
            logOut();
          } else {
            this.isLoading = false;
            alert("Tailor Expenses updating failed, " + err.response.data.message);
            // console.log(err);
          }
        });
    },
    fetchTailorOrders() {
      // Show Loader
      this.isLoading = true;

      // Get Slides Data
      return axios
        .get(`${herokuUrl}/tailor_orders`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        })
        .then((res) => {
          console.log(res.data);
          this.orders = res.data.orders;
          this.tailor_expenses = res.data.tailor_expenses;
          this.tailor_extra_expenses = res.data.tailor_extra_expenses;
          // Stop the loader
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 401) {
            logOut();
          } else {
            this.isLoading = false;
            alert("Banner fetching failed, " + err.response.data.message);
            // console.log(err);
          }
        });
    },
    updateOrderStatus(order) {
      // Show Loader
      this.isLoading = true;
      // Get Slides Data
      return axios
        .post(`${herokuUrl}/tailor_order_update`, {id:order.id, status:order.status}, {
          headers: {
            Authorization: getCookie("user"),
          },
        })
        .then((res) => {
          console.log(res.data);
          alert("Order Status Updated Successfully");

          // Stop the loader
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 401) {
            logOut();
          } else {
            this.isLoading = false;
            alert("Tailor orders fetching failed, " + err.response.data.message);
            // console.log(err);
          }
        });
    },
  },
  components: {
    appNavigation: Navigation,
  },
};
</script>
